import { render } from "./ProfileSettings.vue?vue&type=template&id=2f673103&ts=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=ts"
export * from "./ProfileSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__